import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=224c7174&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224c7174')) {
      api.createRecord('224c7174', component.options)
    } else {
      api.reload('224c7174', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=224c7174&", function () {
      api.rerender('224c7174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/pricehelp.vue"
export default component.exports